exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.clickable-row[data-v-befa09e2]{\n  cursor: pointer;\n}\n.dark-on-hover[data-v-befa09e2]{\n  padding: 10px 20px;\n  margin: -10px 0px;\n}\n.dark-on-hover[data-v-befa09e2]:hover{\n  background-color: rgba(0, 0, 0, 0.03);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-befa09e2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Groups/Groups.vue
// module id = 1+6L
// module chunks = 1